/**
 * Genera una contraseña segura con los requisitos especificados
 * @param {number} length - Longitud de la contraseña (por defecto 16)
 * @returns {string} - Contraseña generada
 */
export const generateSecurePassword = (length = 16) => {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const special = '!@#$%^&*()_+-=[]{}|;:,.<>?';
    
    const allCharacters = lowercase + uppercase + numbers + special;
    
    let password = '';
    
    // Asegurar que la contraseña tenga al menos un carácter de cada tipo
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += special[Math.floor(Math.random() * special.length)];
    
    // Completar el resto de la contraseña con caracteres aleatorios
    for (let i = password.length; i < length; i++) {
        password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
    }
    
    // Mezclar la contraseña para que los caracteres garantizados no estén al principio
    return password.split('').sort(() => Math.random() - 0.5).join('');
};

/**
 * Valida la fortaleza de la contraseña
 * @param {string} password - Contraseña a validar
 * @returns {object} - Objeto con información de validación
 */
export const validatePasswordStrength = (password) => {
    const checks = {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        numbers: /\d/.test(password),
        special: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
    };

    const score = Object.values(checks).filter(Boolean).length;
    
    let strength = 'muy débil';
    if (score === 1) strength = 'débil';
    else if (score === 2) strength = 'aceptable';
    else if (score === 3) strength = 'buena';
    else if (score === 4) strength = 'fuerte';
    else if (score === 5) strength = 'muy fuerte';

    return {
        score,
        strength,
        checks,
        isValid: score >= 3 // Requiere al menos 3 de 5 requisitos
    };
};
